import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { IPhoneCallTag, PhoneCallDirections, PhoneCallTypes } from 'voxloud-types/dist/models';
import { CompanyCallHistoryService } from '../../../services/company-call-history/company-call-history.service';
import { DropdownItemModel } from 'ng-voxloud';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'general-list',
  templateUrl: './general-list.component.html',
  styleUrls: [
    './general-list.component.scss',
    '../company-call-history-common-list-style.scss'
  ]
})
export class GeneralListComponent {
  @Input() callItem: UICallHistoryItem;
  @Input() language: string = 'it';
  @Input() set allTags(v: IPhoneCallTag[]) {
    if(v){
      this._allTags = v.map(this.mapTagsToDropdownItemModel);
    }
  }

  @Output() startCall: EventEmitter<string> = new EventEmitter();
  @Output() openLink: EventEmitter<string> = new EventEmitter();
  @Output() updatedCallLog: EventEmitter<UICallHistoryItem> = new EventEmitter();

  public PhoneCallDirections = PhoneCallDirections;
  public PhoneCallTypes = PhoneCallTypes;
  public dateFormat = {
    short: 'MM/dd/yy HH:mm',
    long: 'MMM dd yyyy HH:mm:ss'
  };
  
  // Notes
  public tmpNotes: string = '';
  public isEditingNotes: boolean = false;
  public isSavingNotes: boolean = false;
  public notesError: boolean = false;
  // Tags
  public tmpTags: FormControl<DropdownItemModel[]> = new FormControl([]);
  public isEditingTags: boolean = false;
  public isSavingTags: boolean = false;
  public tagsError: boolean = false;
  public _allTags: DropdownItemModel[] = [];

  constructor(
    private companyCallHistoryService: CompanyCallHistoryService
  ){}

  ngOnInit() {
    this.tmpNotes = this.callItem.notes;
    this.tmpTags.patchValue(this.callItem.tags.map(this.mapTagsToDropdownItemModel), {
      emitEvent: false
    });
  }

  public linkClick(link: string): void {
    this.openLink.emit(link);
  }

  public callNumber(number: string): void {
    this.startCall.emit(number);
  }

  public isNumber(v: number | string): boolean {
    return typeof v === 'number';
  }

  public onEnableEditingNotes() {
    this.isEditingNotes = true;
  }

  public onCancelEditingNotes() {
    this.isEditingNotes = false;
    this.tmpNotes = this.callItem.notes;
    this.notesError = false;
  }

  public onSaveNotes() {
    this.isSavingNotes = true;
    this.companyCallHistoryService.updateCallLogEvent(this.callItem.id, this.tmpNotes, this.callItem.tags).subscribe({
      next: (response) => {
        this.isEditingNotes = false;
        this.isSavingNotes = false;
        this.notesError = false;
        this.tmpNotes = response.notes;
        this.updatedCallLog.emit(response);
      },
      error: (error) => {
        this.isSavingNotes = false;
        this.notesError = true;
      }
    })
  }

  public onEnableEditingTags() {
    this.isEditingTags = true;
  }

  public onCancelEditingTags() {
    this.isEditingTags = false;
    this.tmpTags.patchValue(this.callItem.tags.map(this.mapTagsToDropdownItemModel), {
      emitEvent: false
    });
    this.tagsError = false;
  }

  public onSaveTags() {
    const payload = this.tmpTags.value ? this.tmpTags.value.map(v => v.data) : [];
    this.isSavingTags = true;
    this.companyCallHistoryService.updateCallLogEvent(this.callItem.id, this.callItem.notes, payload).subscribe({
      next: (response) => {
        this.isEditingTags = false;
        this.isSavingTags = false;
        this.tagsError = false;
        this.tmpTags.patchValue(response.tags.map(this.mapTagsToDropdownItemModel), {
          emitEvent: false
        });
        this.updatedCallLog.emit(response);
      },
      error: (error) => {
        this.isSavingTags = false;
        this.tagsError = true;
      }
    })
  }

  private mapTagsToDropdownItemModel(tag: IPhoneCallTag): DropdownItemModel {
    return {
      item_id: String(tag.id),
      item_name: tag.value,
      data: tag
    }
  }
}
